import { createSelector } from "reselect";
import _ from "underscore";

import getFloorId from "../floor_getters/get_floor_id";
import getPipelineRunningProcessesById from "./get_pipeline_running_processes_by_id";
import Pipeline from "../../../models/domain/pipeline";

const getPipelineRunningProcessesForFloor = createSelector([
  getPipelineRunningProcessesById,
  getFloorId,
], (runningProcesses, floorId): Pipeline[] => {
  const allPipelinesById = {};

  _.forEach(runningProcesses, (runningProcess, id) => {
    if (runningProcess.firebaseFloorId === floorId) {
      allPipelinesById[id] = runningProcess;
    }
  });

  const allPipelines: Pipeline[] = _.values(allPipelinesById);

  allPipelines.sort((a: Pipeline, b: Pipeline): number => {
    return b.startDate.getTime() - a.startDate.getTime();
  });

  return allPipelines;
});

export default getPipelineRunningProcessesForFloor;
